import { render, staticRenderFns } from "./SkuDetails.vue?vue&type=template&id=92257172&scoped=true&"
import script from "./SkuDetails.vue?vue&type=script&lang=js&"
export * from "./SkuDetails.vue?vue&type=script&lang=js&"
import style0 from "./SkuDetails.vue?vue&type=style&index=0&id=92257172&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92257172",
  null
  
)

export default component.exports